import { Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, signal, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatResponseList } from '../../models/api/chats.model';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgIconComponent } from '@ng-icons/core';
import { phosphorGraduationCap, phosphorGlobe } from '@ng-icons/phosphor-icons/regular';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

registerLocaleData(localeEs);

@Component({
	selector: 'unir-ai-chat-card',
	standalone: true,
	imports: [CommonModule, ButtonModule, FormsModule, TranslateModule, NgIconComponent],
	templateUrl: './chat-card.component.html',
	styleUrls: ['./chat-card.component.scss']
})
export class ChatCardComponent implements OnInit {
	@Input() chat!: ChatResponseList;

	@Input() currentChatId?: number;

	@Output() chatSelected = new EventEmitter<{ chatId: number; personalityId: number }>();

	@Output() deleteChat = new EventEmitter<number>();

	@Output() newName = new EventEmitter<{ id: number; name: string }>();

	@ViewChild('input') input!: ElementRef<HTMLInputElement>;

	translateService = inject(TranslateService);

	title? = '';

	showDialog = false;

	personalityId = 0;

	edit = signal(false);

	icons: Record<string, string> = {
		academic: phosphorGraduationCap,
		browser: phosphorGlobe
	};

	ngOnInit() {
		this.title = this.chat.chatName;
		this.personalityId = this.chat.personalityId ?? 0;
	}

	removeChat() {
		this.deleteChat.emit(this.chat.chatId);
	}

	renameChat() {
		this.edit.set(true);
		setTimeout(() => {
			this.input.nativeElement.focus();
		}, 0);
	}

	onNameChange() {
		this.edit.set(false);
		if (this.title && this.title !== this.chat.chatName) {
			this.newName.emit({ id: this.chat.chatId, name: this.title });
		}
	}

	openChat() {
		if (this.edit()) {
			return;
		}

		this.showDialog = false;
		this.chatSelected.emit({ chatId: this.chat.chatId, personalityId: this.personalityId });
	}
}
